import React, { useState } from 'react'
import ImagePreviewModal from '../../components/ImagePreviewModal'

// Thumbnails that open the shared lightbox at the clicked photo
const PhotoThumbs = ({ photos = [] }) => {
  const [previewIndex, setPreviewIndex] = useState(null)
  if (!photos.length) return null
  return (
    <div className='acv-thumbs'>
      {photos.map((p, index) => (
        <img key={p.url} src={p.url} alt={p.name} onClick={() => setPreviewIndex(index)} />
      ))}
      <ImagePreviewModal
        visible={previewIndex !== null}
        photos={photos}
        initialIndex={previewIndex || 0}
        onClose={() => setPreviewIndex(null)}
      />
    </div>
  )
}

export default PhotoThumbs
